module.exports = __webpack_public_path__ + "static/media/4n.03895aca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/4n.svg
// module id = 154
// module chunks = 0